<template>
  <v-navigation-drawer
    temporary
    absolute
    app
    v-model="showDrawer"
    :width="drawWidth"
    class="app-drawer"
  >
    <!-- Brand -->
    <div class="drawer-brand">
      <div class="brand-logo">
        <v-icon size="26" color="white">local_shipping</v-icon>
      </div>
      <div class="brand-text">
        <div class="brand-title">Transport App</div>
        <div class="brand-sub">Avimex</div>
      </div>
    </div>

    <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
      <div class="menu-label">Nawigacja</div>
      <v-list nav dense class="px-2 pt-0">
        <v-list-item
          v-for="item in menus"
          :key="item.title"
          @click="go(item.target)"
          :input-value="isActive(item.target)"
          :disabled="item.disabled"
          color="primary"
          class="menu-item"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider class="mx-4 my-2"></v-divider>

      <v-list nav dense class="px-2">
        <v-list-item @click="handleLogout" class="menu-item">
          <v-list-item-icon>
            <v-icon>logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Wyloguj</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </vue-perfect-scrollbar>

    <template v-slot:append>
      <div class="drawer-foot">Avimex · TransportApp</div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar"
export default {
  name: "AppDrawer",
  components: { VuePerfectScrollbar },
  props: {
    expanded: { type: Boolean, default: true },
    drawWidth: { type: [Number, String], default: "260" },
    showDrawer: Boolean
  },
  data() {
    return {
      menus: [
        { title: "Panel", icon: "dashboard", target: "dashboard" },
        { title: "Historia", icon: "history", target: "historia" }
      ],
      scrollSettings: { maxScrollbarLength: 160 }
    }
  },
  methods: {
    isActive(target) {
      return this.$route && this.$route.path.indexOf(target) !== -1
    },
    go(target) {
      if (!this.isActive(target)) this.$router.push(target)
    },
    delete_cookie(name) {
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;'
    },
    handleLogout() {
      this.delete_cookie("jwt")
      this.$router.push('/auth/login')
    }
  }
}
</script>

<style scoped lang="css">
.app-drawer >>> .drawer-menu--scroll {
  height: calc(100vh - 84px);
  overflow: auto;
}
.drawer-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 18px;
  background: linear-gradient(135deg, #2563EB 0%, #4F46E5 100%);
  color: #fff;
}
.brand-logo {
  width: 44px;
  height: 44px;
  border-radius: 13px;
  background: rgba(255, 255, 255, .16);
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}
.brand-title { font-size: 16px; font-weight: 800; letter-spacing: -.2px; line-height: 1.1; }
.brand-sub { font-size: 12px; opacity: .8; }
.menu-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #94A3B8;
  padding: 16px 20px 6px;
}
.menu-item {
  border-radius: 12px !important;
  margin: 3px 0;
  min-height: 46px;
}
.drawer-foot {
  text-align: center;
  font-size: 11px;
  color: #94A3B8;
  padding: 12px 0;
  border-top: 1px solid #E6EAF0;
}
</style>
